export enum SignUpMessages {
  signUpTitlePage = "signUp.title.page",
  signUpEmailLabel = "signUp.email.label",
  signUpFullNameLabel = "signUp.fullName.label",
  signUpDocumentLabel = "signUp.document.label",
  signUpRoleLabel = "signUp.role.label",
  signUpPhoneNumberLabel = "signUp.phoneNumber.label",
  signUpClientNameLabel = "signUp.clientName.label",
  signUpClientName = "signUp.clientName",
  signUpPasswordLabel = "signUp.password.label",
  signUpPasswordConfirmationLabel = "signUp.passwordConfirmation.label",
  signUpButton = "signUp.button",
  signUpRequiredEmail = "signUp.required.email",
  signUpInvalidEmail = "signUp.invalid.email",
  signUpFullNameRequired = "signUp.fullName.required",
  signUpPasswordRequired = "signUp.password.required",
  signUpPasswordConfirmationRequired = "signUp.passwordConfirmation.required",
  signUpPasswordConfirmationMatch = "signUp.passwordConfirmation.match",
  signUpFailed = "signUp.failed"
}

export interface TranslationSignUpMessages {
  [SignUpMessages.signUpTitlePage]: string;
  [SignUpMessages.signUpEmailLabel]: string;
  [SignUpMessages.signUpFullNameLabel]: string;
  [SignUpMessages.signUpDocumentLabel]: string;
  [SignUpMessages.signUpRoleLabel]: string;
  [SignUpMessages.signUpPhoneNumberLabel]: string;
  [SignUpMessages.signUpClientName]: string;
  [SignUpMessages.signUpClientNameLabel]: string;
  [SignUpMessages.signUpPasswordLabel]: string;
  [SignUpMessages.signUpPasswordConfirmationLabel]: string;
  [SignUpMessages.signUpButton]: string;
  [SignUpMessages.signUpRequiredEmail]: string;
  [SignUpMessages.signUpInvalidEmail]: string;
  [SignUpMessages.signUpFullNameRequired]: string;
  [SignUpMessages.signUpPasswordRequired]: string;
  [SignUpMessages.signUpPasswordConfirmationRequired]: string;
  [SignUpMessages.signUpPasswordConfirmationMatch]: string;
  [SignUpMessages.signUpFailed]: string;
}
